var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"hierarchical-list"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,staticClass:"hierarchical-list__item",attrs:{"data-test":"hierarchical-item"}},[_vm._t("default",null,null,{ ...item })],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }